import DateTimeTermVO from '../../domain/value-object/DateTimeTermVO'
import { dateVoService } from '../../domain/value-object/DateVO'
import { WbsItemSearchConditionV2VO } from '../../domain/value-object/WbsItemSearchConditionV2Vo'
import objects from '../../utils/objects'
import { StoredWbsItemSearchCondition } from '../model/storedWbsItemSearchCondition'

type StoredWbsItemSearchConditionV2 = StoredWbsItemSearchCondition & {
  version?: number
}

type WbsItemSearchConditionV2SerializeService = {
  fromVoToStoredObject: (
    src: WbsItemSearchConditionV2VO
  ) => StoredWbsItemSearchConditionV2
}

export const useWbsItemSearchConditionV2SerializeService =
  (): WbsItemSearchConditionV2SerializeService => {
    const fromVoToStoredObject = (
      src: WbsItemSearchConditionV2VO
    ): StoredWbsItemSearchConditionV2 => {
      const dest: StoredWbsItemSearchConditionV2 = {}
      for (let entry of Object.entries(src)) {
        const key = entry[0]
        const value = entry[1]
        // DateVO has to be transformed.
        if (
          [
            'scheduledStartDate',
            'scheduledEndDate',
            'actualStartDate',
            'actualEndDate',
          ].includes(key)
        ) {
          if (typeof value !== 'object') continue
          const from = !!value['from']
            ? dateVoService.toString(value['from'])
            : undefined
          const to = !!value['to']
            ? dateVoService.toString(value['to'])
            : undefined
          objects.setValue(dest, key, { from, to })
          continue
        }
        // DateTimeVO has to be transformed.
        if (['createdAt', 'updatedAt'].includes(key)) {
          const v =
            value instanceof DateTimeTermVO ? value.serialize() : undefined
          objects.setValue(dest, key, v)
          continue
        }

        // if properties of blank is all false, it does not set.
        if (key === 'blank') {
          if (Object.values(value).every(v => !v)) {
            continue
          }
        }
        objects.setValue(dest, key, value)
      }
      // V2 always stores with version: 2
      dest.version = 2
      return dest
    }

    return {
      fromVoToStoredObject,
    }
  }
